import classnames from 'classnames';
import type { PropsWithChildren, ReactElement } from 'react';
import { ModalCloseButton } from './ModalCloseButton';
import styles from './ModalWindow.module.scss';

export const modalWindowClass = styles.content;

type ModalWindowProps = PropsWithChildren<{
  onClose: () => void;
  className?: string;
}>;

export function ModalWindow(props: ModalWindowProps): ReactElement {
  return (
    <div
      className={classnames(styles.content, props.className)}
      role="dialog"
      aria-modal="true"
    >
      {props.children}
      <ModalCloseButton onClick={props.onClose} />
    </div>
  );
}
